import React from 'react';
import { CheckCircle } from 'lucide-react';

const About = () => {
  const highlights = [
    { id: 'equipment', text: 'Advanced surveying equipment and technology' },
    { id: 'team', text: 'Experienced team of professional surveyors' },
    { id: 'clients', text: 'Serving developers, contractors, and engineers' },
    { id: 'trust', text: 'Trusted partner for construction projects' }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_hbm-survey-main/artifacts/rafhcrjq_IMG_3093.jpeg"
                alt="HBM Survey Projects Team at Work"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent"></div>
            </div>
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-2xl p-6 border-t-4 border-blue-900">
              <div className="text-4xl font-bold text-blue-900">10+</div>
              <div className="text-gray-600 font-medium">Years of Excellence</div>
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-blue-50 text-blue-900 rounded-full text-sm font-semibold mb-4">
              About HBM Survey Projects
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Professional Land Surveying Services
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              HBM Survey Projects provides professional land surveying services for construction, land development, and property planning.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our team uses advanced surveying equipment and modern technology to deliver accurate measurements that engineers, contractors, and developers can rely on.
            </p>

            {/* Highlights */}
            <div className="space-y-4">
              {highlights.map((highlight) => (
                <div key={highlight.id} className="flex items-start gap-3 group">
                  <div className="flex-shrink-0 w-6 h-6 bg-blue-900 rounded-full flex items-center justify-center mt-0.5 group-hover:scale-110 transition-transform">
                    <CheckCircle className="w-4 h-4 text-white" />
                  </div>
                  <p className="text-gray-700 font-medium">{highlight.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
